import { connect } from 'react-redux';
import FilterText from '../components/FilterText';

const filterSelector = (state, props) =>
  state.tools && state.tools[props.filter];

const mapStateToProps = (state, props) => ({
  filter: filterSelector(state, props),
});

export default connect(mapStateToProps)(FilterText);



// WEBPACK FOOTER //
// ./src/containers/ToolFilterText.js